import React, { ReactNode } from 'react';

import { Textarea } from 'components/Textarea';

import { Field } from './Field';

type Props = {
  description?: string | ReactNode;
  noMargin?: boolean;
  label?: string;
  maxLength?: number;
  name: string;
  onUpdateValue?: (arg0: string) => void;
  placeholder?: string;
  rows?: number;
  value?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (arg0: Record<string, any>) => void;
  onKeyPress?: (arg0: React.KeyboardEvent) => void;
};

export function TextAreaField({
  name,
  noMargin,
  label,
  description,
  placeholder,
  maxLength,
  onUpdateValue,
  ...props
}: Props) {
  return (
    <Field
      inputProps={props}
      name={name}
      label={label}
      noMargin={noMargin}
      description={description}
      renderInput={({ value, id, qaId, hasError, updateValue }) => (
        <Textarea
          id={id}
          name={name}
          value={value || ''}
          hasError={hasError}
          data-qa-id={qaId}
          maxLength={maxLength}
          onChange={(e) => {
            updateValue(e.target.value);

            if (onUpdateValue) {
              onUpdateValue(e.target.value);
            }
          }}
          placeholder={placeholder}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        />
      )}
    />
  );
}
